import { Privilege, User } from '../../clients/aasServerClient.generated';
import * as actionCreators from './actionCreators';
import { ActionTypeNames } from './actions';
import { State } from './state';

const initialState: State = {
    alias: undefined,
    authenticated: false,
    initialized: false,
    privileges: undefined,
    selfInfo: undefined,
    sso: false,
    user: undefined,
    organizationName: "",

    dialogSuccess: false,
    invalidToken: undefined,

    about: undefined,
    sessions: undefined,
    theme: undefined,

    loadingApplication: false,
    task: "",
    url: "",
    application: "",
    queryString: ""
};

type Actions = ReturnType<typeof actionCreators[keyof typeof actionCreators]>;

export default function reducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionTypeNames.AuthenticationStateChanged:
            return {
                ...state,
                initialized: true,
                ...action.newState,
            };
        case ActionTypeNames.DialogSuccess:
            return {
                ...state,
                dialogSuccess: true,
            };
        case ActionTypeNames.DialogClear:
            return {
                ...state,
                dialogSuccess: false,
            };
        case ActionTypeNames.SetInvalidToken:
            return {
                ...state,
                invalidToken: action.invalidToken,
            };
        case ActionTypeNames.InvalidTokenClear:
            return {
                ...state,
                invalidToken: undefined,
            };
        case ActionTypeNames.SetTheme:
            return {
                ...state,
                theme: action.theme,
            };
        case ActionTypeNames.SetAbout:
            return {
                ...state,
                about: action.about,
            };
        case ActionTypeNames.SetSessions:
            return {
                ...state,
                sessions: action.sessions,
            };
        case ActionTypeNames.SetSelfInfo:
            return {
                ...state,
                selfInfo: action.selfInfo,
            };
        case ActionTypeNames.GoToApplication:
            return {
                ...state,
                loadingApplication: true,
            };
        case ActionTypeNames.ResetLoadingApplication:
            return {
                ...state,
                loadingApplication: false,
            };
        case ActionTypeNames.SetAuthReqSource:
            return {
                ...state,
                task: action.task,
                url: action.url,
                application: action.application,
                queryString: action.queryString,
            };
        default:
            return state;
    }
}